import { useEffect, useState } from 'react'

export interface ReferenceImagePreset {
    id: string
    label: string
    thumbnail: string
    url: string
}

export interface ReferenceImageCategory {
    name: string
    presets: ReferenceImagePreset[]
}

interface PresetsConfig {
    categories: ReferenceImageCategory[]
}

/**
 * Loads reference image presets from /config/referenceImagePresets.json.
 * Designed to be replaced with a remote config URL later — only this hook needs updating.
 */
export const useReferenceImagePresets = () => {
    const [categories, setCategories] = useState<ReferenceImageCategory[]>([])
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        setIsLoading(true)
        fetch('/config/referenceImagePresets.json')
            .then((res) => {
                if (!res.ok) throw new Error('Failed to load presets')
                return res.json() as Promise<PresetsConfig>
            })
            .then((data) => {
                setCategories(data.categories)
                setError(null)
            })
            .catch((err) => {
                setError(err.message)
            })
            .finally(() => setIsLoading(false))
    }, [])

    return { categories, isLoading, error }
}
